export default "__VITE_ASSET__CpsAqLnb__"